import {Component, OnDestroy, OnInit} from '@angular/core';
import {Store} from '@ngxs/store';
import {Post, User} from 'jugacu-lib';
import {WhistlerAPIService} from '../../whistler-api.service';
import {IdcAPIService} from '../../idc-api.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {
    breakpoint: number;

    amaiaCounterIsLoading = true;
    amaiaCounter: number;

    idcCounterIsLoading = true;
    idcCounter: number;

    idcIsLoading = true;
    idcHasError = false;
    idcColumns = ['Created at', 'Title', 'Author', 'Contents'];
    idcSource: Post[] = [];

    amaiaIsLoading = true;
    amaiaHasError = false;
    amaiaColumns = ['Created at', 'Name', 'Email'];
    amaiaSource: User[];

    constructor(
        private readonly store: Store,
        private readonly whistlerAPIService: WhistlerAPIService,
        private readonly idcAPIService: IdcAPIService,
    ) {
    }

    async ngOnInit() {
        this.breakpoint = (window.innerWidth <= 400) ? 1 : 4;

        this.loadIdcPostDataSource();
        this.loadAmaiaUsersDataSource();
        this.loadAmaiaUserCount();
        this.loadIdcContentCount();
    }

    private async loadIdcPostDataSource(): Promise<void> {
        try {
            const response = await this.idcAPIService.getPosts();
            this.idcSource = response.data.slice(0, 7);
        } catch (e) {
            this.idcHasError = true;
        } finally {
            this.idcIsLoading = false;
        }
    }

    private async loadAmaiaUsersDataSource(): Promise<void> {
        try {
            const users = (await this.whistlerAPIService.getUsers(0, 'desc')).data.content;
            this.amaiaSource = users.slice(0, 7);
        } catch (e) {
            this.amaiaHasError = true;
        } finally {
            this.amaiaIsLoading = false;
        }
    }

    private async loadAmaiaUserCount(): Promise<void> {
        try {
            const response = await this.whistlerAPIService.getAmaiaUserCount();
            this.amaiaCounter = response.data;
        } catch (e) {
            //
        } finally {
            this.amaiaCounterIsLoading = false;
        }
    }

    private async loadIdcContentCount() {
        try {
            const response = await this.idcAPIService.getIdcContentsCount();
            this.idcCounter = response.data;
        } catch (e) {
            //
        } finally {
            this.idcCounterIsLoading = false;
        }
    }

    onResize(event: any) {
        this.breakpoint = (event.target.innerWidth <= 400) ? 1 : 4;
    }

    ngOnDestroy(): void {
    }

    goToIdcPost(post: Post) {
        window.open(`https://idc.jugacu.es/post/${post.id}`, '_blank');
    }
}
